import {
    JOIN_TO_UNIT,
} from 'state/actions/join_unit'

const initialState = {
    inProgress: false,
    errorMessage: '',
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case JOIN_TO_UNIT: {
        return {
            ...state,
            inProgress: true,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/units/join_unit.js